import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Title, SubTitle, Text, Button } from "../theme";
import { checkStoredOrPromptPassword } from "../utilities/passwordCookie";

const protectedPages = [
  {
    title: "Vote",
    path: "/vote",
    services: "Accept or unaccept submitted memes by edition and category.",
  },
  {
    title: "Meme Table",
    path: "/table",
    services: "Inspect meme data in a sortable table with configurable columns.",
  },
  {
    title: "Downloads",
    path: "/downloads",
    services:
      "Download memes per edition as grouped folders by first tag, or as a flat zip.",
  },
  {
    title: "Tagger Insights",
    path: "/taggerinsights",
    services:
      "Review meme counts per category and subcategory, plus average tag counts per edition.",
  },
  {
    title: "Tagger",
    path: "/tagger",
    services:
      "Tag memes by edition and tag count criteria, then save taxonomy changes to the CMS.",
  },
  {
    title: "Simple Gallery",
    path: "/simple/:edition",
    services:
      "Open a simple image gallery for one edition. Replace :edition with the edition number, for example /simple/2025.",
  },
];

const Admin = () => {
  const settings = useSelector((state) => state.data.settings);
  const [secure, setSecure] = useState(null);

  useEffect(() => {
    if (secure === null && settings) {
      setSecure(checkStoredOrPromptPassword(settings.password));
    }
  }, [secure, settings]);

  if (!settings) {
    return null;
  }

  if (secure === false) {
    return (
      <Row center="xs">
        <Col xs={12}>
          <Title>ADMIN</Title>
          <Text>Wrong password.</Text>
        </Col>
      </Row>
    );
  }

  if (!secure) {
    return null;
  }

  return (
    <>
      <Row center="xs">
        <Col xs={12}>
          <Title>ADMIN</Title>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Text>Protected pages and their services.</Text>
        </Col>
      </Row>

      {protectedPages.map(({ title, path, services }) => (
        <Row key={path}>
          <Col xs={12}>
            <SubTitle>{title}</SubTitle>
            <Text>
              <strong>{path}</strong>
            </Text>
            <Text>{services}</Text>
            <Button
              text="Open"
              url={path.includes(":") ? path.replace(":edition", "2025") : path}
              redirect
            />
            <br />
          </Col>
        </Row>
      ))}
    </>
  );
};

export default Admin;
